import React from 'react';
import styles from './LineItemsSubtable.module.scss';
import { money2 } from '../../utils';
import type { SkuLineItem } from '../../types';

interface LineItemsSubtableProps {
  skus: SkuLineItem[];
}

export function LineItemsSubtable({ skus }: LineItemsSubtableProps) {
  return (
    <table className={styles.table}>
      <thead>
        <tr className={styles.headRow}>
          <th className={`${styles.th} ${styles.first}`}>SKU</th>
          <th className={styles.th}>Description</th>
          <th className={styles.th}>Qty</th>
          <th className={styles.th}>Unit price</th>
          <th className={styles.th}>Line total</th>
        </tr>
      </thead>
      <tbody>
        {skus.map((s, i) => (
          <tr key={i} className={styles.row}>
            <td className={`${styles.code} ${styles.first}`}>{s.code}</td>
            <td className={styles.text}>{s.description}</td>
            <td className={styles.text}>{s.qty}</td>
            <td className={styles.mono}>{money2(s.unitPrice)}</td>
            <td className={styles.total}>{money2(s.qty * s.unitPrice)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
